module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9BfNq"))).then(() => module.bundle.root('2KbAe'));